import { Button } from '@/components/Button'
import { ErrorBlock } from '@/components/ErrorBlock'
import { Form, FormRow } from '@/components/Form'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { type ReactNode } from 'react'

export interface TransferJobDialogProps {
  showing: boolean
  jobCount: number
  optionField: ReactNode
  transferEditor: ReactNode
  reasonField: ReactNode
  otherReasonField: ReactNode
  showRateProButton: boolean
  isTransferPending: boolean
  isTransferRejected: boolean
  isTransferDisabled: boolean
  transferError: unknown
  onRatePro: () => unknown
  onClose: () => unknown
  onTransfer: () => unknown
}

export function TransferJobDialog({
  showing,
  jobCount,
  optionField,
  transferEditor,
  reasonField,
  otherReasonField,
  showRateProButton,
  isTransferPending,
  isTransferRejected,
  isTransferDisabled,
  transferError,
  onRatePro,
  onClose,
  onTransfer,
}: TransferJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isTransferPending ? undefined : onClose}
      disableCloseOnEsc
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>
          Transfer {jobCount > 1 ? `${jobCount} Jobs` : 'Job'}
        </ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <ModalSheetContentBlock expanded>
          <Form>
            <FormRow>{optionField}</FormRow>

            {transferEditor}

            <FormRow>{reasonField}</FormRow>

            {otherReasonField && <FormRow>{otherReasonField}</FormRow>}
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      {isTransferRejected && (
        <ErrorBlock tackOn="bottom" error={transferError} />
      )}

      <ModalSheetFooter>
        <ModalSheetFooterButtonGroup>
          {showRateProButton && (
            <Button
              label="Rate Pro"
              variant="default"
              onPress={onRatePro}
              testId="transfer-job-rate-pro-button"
            />
          )}
        </ModalSheetFooterButtonGroup>

        <ModalSheetFooterSpacer />

        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isTransferPending}
            variant="default"
            onPress={onClose}
            testId="transfer-job-close-button"
          />
          <Button
            label="Transfer"
            variant="primary"
            isPending={isTransferPending}
            onPress={onTransfer}
            testId="transfer-job-submit-button"
            isDisabled={isTransferDisabled}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
